// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"93":"ff89cabe","756":"d917ebde","2113":"d917ebde","4255":"976712ec"}[chunkId] + ".chunk.css";
};